import { render, staticRenderFns } from "./SelectionBox.vue?vue&type=template&id=0339116d&scoped=true&"
import script from "./SelectionBox.vue?vue&type=script&lang=js&"
export * from "./SelectionBox.vue?vue&type=script&lang=js&"
import style0 from "./SelectionBox.vue?vue&type=style&index=0&id=0339116d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0339116d",
  null
  
)

export default component.exports